export default {
  billedOptions: [{
    label: "Billed",
    value: "Final"
  }, {
    label: "Draft",
    value: "Interim"
  }, {
    label: "WIP",
    value: "wip"
  }, {
    label: "Not Billed",
    value: "notFinal"
  }, {
    label: "All",
    value: "all"
  }],
  attachmentOptions: [{
    label: "With Attachment",
    value: "withAttachment"
  }, {
    label: "Without Attachment",
    value: "withoutAttachment"
  }, {
    label: "All",
    value: "all"
  }],
  paidOptions: [{
    label: "Ready to Pay",
    value: "pay"
  }, {
    label: "Wait to Pay",
    value: "wait"
  }, {
    label: "Paid",
    value: "paid"
  }, {
    label: "All",
    value: "all"
  }],
  expenseTypes: [{
    label: "All",
    value: "All"
  }, {
    label: "Created in LeanLaw",
    value: "LeanLaw"
  }, {
    label: "Created in QuickBooks",
    value: "QuickBooks"
  }, {
    label: "QuickBooks Expense",
    value: "Expense"
  }, {
    label: "QuickBooks Bill",
    value: "Bill"
  }, {
    label: "QuickBooks Check",
    value: "Check"
  }, {
    label: "QuickBooks Journal Entry",
    value: "JournalEntry"
  }],
  customFlagOptions: [{
    label: "Include",
    value: "any"
  }, {
    label: "Exclude",
    value: "false"
  }, {
    label: "Only",
    value: "true"
  }]
};